module.exports = __webpack_public_path__ + "static/dabanga-1-6d8755deab013f07cf09bf1467e2012b.gif";